import { render, staticRenderFns } from "./FlowCardItem.vue?vue&type=template&id=58c01d70&scoped=true&"
import script from "./FlowCardItem.vue?vue&type=script&lang=js&"
export * from "./FlowCardItem.vue?vue&type=script&lang=js&"
import style0 from "./FlowCardItem.vue?vue&type=style&index=0&id=58c01d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c01d70",
  null
  
)

export default component.exports